export default class WindowUtils {
  static scrollWithOffset = (el: HTMLElement, offset?: number): void => {
    void window.scroll({
      top: el.offsetTop - (offset ?? 0),
      behavior: 'smooth',
    })
  }
}
